import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { ButtonStyles } from '@stories/Components/Buttons/GeneralButton/Button.styles';
import styled from 'styled-components';
export const Container = styled.a `
  overflow: hidden;
  text-decoration: none;
  display: block;
  height: 100%;
  max-width: 556px;
  position: relative;

  &:focus {
    outline: none;
  }

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-color: ${brand.black};
  }
`;
const Inner = styled.div `
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const MediaHolder = styled.div `
  --imageRatio: 340 / 250;
  --svgSize: 60px;

  display: flex;
  place-items: center;
  place-content: center;
  position: relative;
  overflow: hidden;
  border-radius: ${fluid(25, 50)};
  aspect-ratio: var(--imageRatio);
  background-color: var(--cardPlaceholderBgColor);

  @media ${from(Device.TabletSmall)} {
    --imageRatio: 311 / 420;
    --svgSize: 88px;
  }

  svg {
    width: var(--svgSize);
    ${transition('transform')}

    ${Container}:hover & {
      transform: scale(1.05);
    }
  }

  ${Container}[data-square='true'] & {
    --imageRatio: 1 / 1;

    @media ${from(Device.TabletSmall)} {
      --imageRatio: 1 / 1;
    }
  }
`;
const Image = styled.img `
  aspect-ratio: var(--imageRatio);
  object-fit: cover;
  ${transition('transform')}
  width: 100%;
  height: 100%;

  ${Container}:hover & {
    transform: scale(1.05);
  }
`;
const ContentArea = styled.div `
  position: relative;
  flex: 1;
`;
const ContentInner = styled.div `
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 22px 0 17px;
  color: ${brand.grey.grey11};
`;
const ContentTop = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;
`;
const Author = styled.span `
  ${fonts.montserrat.regular};
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 15px;

  @media ${from(Device.Tablet)} {
    margin-bottom: 8px;
  }
`;
const Date = styled.time `
  ${fonts.montserrat.regular};
  font-size: 16px;
  line-height: 32px;
`;
const ReadTime = styled.div `  
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    width: 16px;
    height: 20px;
    margin-bottom: 5px;
  }

  span {
    ${fonts.montserrat.regular};
    font-size: 16px;
    line-height: 32px;
  }
`;
const Caption = styled.span `
  position: absolute;
  top: ${fluid(16, 24)};
  left: ${fluid(16, 24)};
  z-index: 1;

  display: block;
  place-items: center;
  font-size: ${fluid(14, 16)};
  line-height: 30px;
  ${fonts.montserrat.regular};
  padding: 5px ${fluid(20, 24)};
  background-color: var(--primaryPageThemeColor);
  border-radius: 100000px;
  color: ${brand.black};
`;
const Title = styled.h3 `
  font-size: 20px;
  line-height: 32px;
  ${fonts.montserrat.regular};
  margin-bottom: ${fluid(8, 15)};
`;
const FakeButton = styled.div `
  margin-top: auto;
  pointer-events: none;

  ${Container}:hover & {
    ${ButtonStyles.ButtonInner} {
      --textAltColour: ${brand.grey.grey16};
      --hoverColour: ${brand.green.light};

    }

    ${ButtonStyles.Text} {
      transform: translateY(-2px);
    }
  }
`;
export const BlogCardStyles = {
    Author,
    Caption,
    Container,
    ContentArea,
    ContentInner,
    ContentTop,
    Date,
    FakeButton,
    Image,
    Inner,
    MediaHolder,
    ReadTime,
    Title,
};
